import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

const MATERIAL_TO_PHOSPHOR: Record<string, string> = {
  menu: 'list',
  menu_open: 'sidebar-simple',
  edit_square: 'chats',
  edit: 'pencil',
  search: 'magnifying-glass',
  chat: 'clock-counter-clockwise',
  expand_more: 'caret-down',
  expand_less: 'caret-up',
  arrow_drop_down: 'caret-down',
  psychology: 'lightning',
  travel_explore: 'globe',
  open_in_full: 'arrows-out',
  close_fullscreen: 'arrows-in',
  stop_circle: 'pause-circle',
  send: 'arrow-up',
  mic: 'microphone',
  progress_activity: 'circle-notch',
  close: 'x',
  list_alt: 'list-checks',
  check_circle: 'check-circle',
  thumb_up: 'thumbs-up',
  thumb_down: 'thumbs-down',
  check: 'check',
  content_copy: 'copy',
  download: 'download',
  data_usage: 'chart-donut',
  more_horiz: 'dots-three',
  delete: 'trash',
  subscriptions: 'ticket',
  plans: 'ticket',
  query_stats: 'chart-line-up',
  logout: 'sign-out',
  settings: 'gear',
  theme: 'palette',
  question: 'question',
};

@Component({
  selector: 'ui-icon',
  template: `<span [class]="className()" [style.fontSize]="fontSize()" aria-hidden="true"></span>`,
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiIconComponent {
  readonly name = input.required<string>();
  readonly size = input<number | string>(20);

  protected readonly fontSize = computed(() => {
    const size = this.size();

    if (typeof size === 'number') return Number.isFinite(size) ? `${size}px` : '20px';

    const trimmed = size.trim();
    return trimmed.length > 0 ? trimmed : '20px';
  });

  protected readonly className = computed(() => {
    const raw = (this.name() ?? '').trim();

    // Allow direct Phosphor usage:
    // - "ph-magnifying-glass" => used as-is
    // - "magnifying-glass" => becomes "ph-magnifying-glass"
    // - "magnifying_glass" => becomes "ph-magnifying-glass"
    if (raw.startsWith('ph-')) return `ui-icon ph ${raw}`;

    const mapped = MATERIAL_TO_PHOSPHOR[raw] ?? raw.replaceAll('_', '-');
    return `ui-icon ph ph-${mapped}`;
  });
}
